import type { IEdge, IGraph, ILabel, ILabelOwner, INode } from '@ardoq/yfiles';
import {
  formatOtherLabel,
  type GraphItem,
  type GraphEdgeBase,
  GraphNode,
  type YGraphState,
  isAggregatedGraphEdge,
} from '@ardoq/graph';
import { isUrlLabel } from './isUrlLabel';
import { addAggregatedCountLabel, addURLEdgeLabel } from './addGraphLabels';
import { CanvasOtherLabelStyle } from '../../labels/CanvasOtherLabelStyle';
import { INVISIBLE_SEPARATOR } from '../consts';
import { LeafNodeLabelStyle } from '../leafNodeLabel/LeafNodeLabelStyle';

export const updateLabels = (
  owner: ILabelOwner,
  graph: IGraph,
  graphItem: GraphItem
) => {
  const labelsToRemove: ILabel[] = [];
  owner.labels.forEach(label => {
    const { text, owner, style } = label;
    if (style === LeafNodeLabelStyle.Instance) {
      const labelText = graphItem.getItemLabels()?.mainLabel ?? '';
      if (text !== labelText) {
        graph.setLabelText(label, labelText);
        const { tag: nodeTag } = owner as INode;
        const { id } = nodeTag as GraphNode;
        const { tag: graphTag } = graph;
        const { leafNodeLayout } = graphTag as YGraphState;
        const wrappedLabel = leafNodeLayout.get(id)?.wrappedMainLabel ?? [];
        label.tag = wrappedLabel;
      }
    } else if (isUrlLabel(label) && !graphItem.hasURLFields()) {
      labelsToRemove.push(label);
    }
  });
  labelsToRemove.forEach(label => graph.remove(label));
};
export const updateEdgeLabels = (
  edge: IEdge,
  graph: IGraph,
  graphEdge: GraphEdgeBase,
  isModern: boolean
) => {
  const labelsToRemove = edge.labels.toArray();
  for (const label of labelsToRemove) {
    graph.remove(label);
  }
  const itemLabels = graphEdge.getItemLabels();
  if (!itemLabels) {
    return;
  }
  const { mainLabel, otherLabels } = itemLabels;
  if (mainLabel) {
    graph.addLabel(edge, mainLabel);
  }

  if (graphEdge.hasURLFields()) {
    addURLEdgeLabel(graph, edge, graphEdge, isModern);
  }
  if (isAggregatedGraphEdge(graphEdge)) {
    addAggregatedCountLabel(graph, edge, graphEdge);
  }
  if (!otherLabels?.length || !isModern) {
    return;
  }
  const styles = otherLabels.map(l => l[3]);
  const { id } = graphEdge;
  graph.addLabel({
    owner: edge,
    text: otherLabels.map(formatOtherLabel).join(INVISIBLE_SEPARATOR),
    style: new CanvasOtherLabelStyle(styles),
    tag: (graph.tag as YGraphState).edgeOtherLabels.get(id) ?? null,
  });
};
